
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '@/author/constants';
import BaseComponent from '@/author/components/BaseComponent.vue';
import ModalStackChildren from '@/mixins/ModalStackChildren';

@Component
export default class ModalStack extends BaseComponent {
  @Prop({default: false}) indexedOrder?: boolean;
  modals!: any[];
  lenghtCompleted = 0;
  completedModals: number[] = [];
  isInteractive :boolean = true;
  indexedModal = 0;

  created() {
    this.modals = this.$children;
    this.$on(EVENTS.COMPLETED, this.onEventsCompleted);
  }

  onEventsCompleted (hash:number) {
    if (hash) {
      this.completeModal(hash);
      this.checkIfStackIsCompleted();
    }
  }

  mounted() {
    this.modals = this.$children;
    var completed: boolean = this.getSavedData && this.getSavedData.completed;
    this.defineCompleteState(completed);
    this.setupModalsFromSavedData(this.getSavedData);
  }

  defineCompleteState(completed: boolean) {
    if (completed !== undefined && completed) 
      this.unlock();
    else 
      this.lockForward();
    
  }

  checkIfStackIsCompleted() {
    this.lenghtCompleted = 0;
    this.modals.forEach(modal => {
      if ((modal as ModalStackChildren).completed) {
        this.indexedModalOpen(modal.$options.propsData.indexNumber);
        this.lenghtCompleted += 1;
      }
    });

    if (this.completed) this.unlock();

    this.saveData({
      completedModals: this.completedModals,
      completed: this.completed
    });
  }

  indexedModalOpen(modalIndexNumber?: number){
    if(modalIndexNumber !== undefined){
      const isGreaterIndex = this.indexedModal <= modalIndexNumber && this.indexedOrder;
      if (isGreaterIndex) this.indexedModal = modalIndexNumber + 1;
    }
    if (this.indexedOrder) this.$emit('open-modal', this.indexedModal);
  }

  completeModal(hash: number) {
    if (this.completedModals.indexOf(hash) === -1)
      this.completedModals.push(hash);
    this.saveData({
      completedModals: this.completedModals,
      completed: this.completed
    });
  }

  setupModalsFromSavedData(savedData: any) {
    if (savedData && savedData.completedModals) {
      this.completedModals = savedData.completedModals;
      if (this.indexedOrder) this.indexedModal = savedData.completedModals.length;
      this.completedModals.map(hash => {
        this.$emit('setup-modal', hash);
        this.indexedModalOpen();
      });
    }
  }

  get completed(): boolean {
    return this.modals.length === this.lenghtCompleted;
  }
}
